import { AxiosResponse } from 'axios';
import { giftCardActions } from 'modules/gift-card/services/slice';
import { IProductByAllCategoryData } from 'modules/settings/general_configuration/pages/promotions/components/Form/ProductSelector';
import { all, call, delay, put, takeLatest } from 'redux-saga/effects';
import { IResponseData } from 'services/response';
import { IFeeCreditCardResData } from '../types/fee';
import { IPaymentOtherItem } from '../types/payment';
import { ITaxSettingResData } from '../types/tax';
import shopApis from './apis';
import { actions } from './slice';
import { IProductVIPItemData } from '../types/vip';

const getCategories = function* () {
  try {
    const res: IResponseData<any> = yield call(shopApis.categories);
    if (res.data.data) {
      yield put(actions.async.getCategories.success(res.data.data));
    }
  } catch (error) {
    yield put(actions.async.getCategories.fail({}));
  }
};

const getStaffs = function* () {
  try {
    const res: IResponseData<any> = yield call(shopApis.getStaffs);
    if (res.data.data) {
      yield put(actions.async.getStaffs.success(res.data.data));
    }
  } catch (error) {
    yield put(actions.async.getStaffs.fail({}));
  }
};

const getSettingTax = function* () {
  try {
    const res: IResponseData<ITaxSettingResData> = yield call(
      shopApis.settingTax
    );
    if (res.data.data) {
      yield put(actions.async.getSettingTax.success(res.data.data));
    }
  } catch (error) {
    yield put(actions.async.getSettingTax.fail({}));
  }
};

const getFeeCreditCard = function* () {
  try {
    const res: IResponseData<IFeeCreditCardResData> = yield call(
      shopApis.feeCreditCard
    );
    if (res.data.data) {
      yield put(actions.async.getFeeCreditCard.success(res.data.data));
    }
  } catch (error) {
    yield put(actions.async.getFeeCreditCard.fail({}));
  }
};

const getCashIncentive = function* () {
  try {
    const res: IResponseData<IFeeCreditCardResData> = yield call(
      shopApis.cashIncentive
    );
    if (res.data.data) {
      yield put(actions.async.getCashIncentive.success(res.data.data));
    }
  } catch (error) {
    yield put(actions.async.getCashIncentive.fail({}));
  }
};

const getShopInfo = function* () {
  try {
    const res: IResponseData<IFeeCreditCardResData> = yield call(
      shopApis.shopInfo
    );
    if (res.data.data) {
      yield put(actions.async.getShopInfo.success(res.data.data));
    }
  } catch (error) {
    yield put(actions.async.getShopInfo.fail({}));
  }
};

const getPaymentOthers = function* () {
  try {
    const res: IResponseData<IPaymentOtherItem[]> = yield call(
      shopApis.paymentOthers
    );
    if (res.data.data) {
      yield put(actions.async.getPaymentOthers.success(res.data.data));
    }
  } catch (error) {
    yield put(actions.async.getPaymentOthers.fail({}));
  }
};

const getLoyaltyProgram = function* () {
  try {
    const res: IResponseData<IPaymentOtherItem[]> = yield call(
      shopApis.loyaltyProgram
    );
    if (res.data.data) {
      yield put(actions.async.getLoyaltyProgram.success(res.data.data));
    }
  } catch (error) {
    yield put(actions.async.getLoyaltyProgram.fail({}));
  }
};
const getPackageVip = function* () {
  try {
    const res: IResponseData<IProductVIPItemData[]> = yield call(
      shopApis.packageVip
    );
    if (res.data.data) {
      yield put(actions.async.getPackageVip.success(res.data.data));
    }
  } catch (error) {
    yield put(actions.async.getPackageVip.fail({}));
  }
};

const initData = function* () {
  yield delay(200);
  yield all([put(actions.async.getCategories.fetch())]);
  yield all([
    put(actions.async.getCategories.fetch()),
    put(actions.async.getStaffs.fetch()),
    put(actions.async.getSettingTax.fetch()),
    put(actions.async.getCashIncentive.fetch()),
    put(actions.async.getShopInfo.fetch()),
    put(actions.async.getFeeCreditCard.fetch()),
    put(actions.async.getPaymentOthers.fetch()),
    put(actions.async.getLoyaltyProgram.fetch()),
    put(actions.async.getPackageVip.fetch()),
    put(giftCardActions.async.getInitialCustomers.fetch()),
  ]);
};

function* getAllProductByCategory() {
  try {
    const res: AxiosResponse<{ data: IProductByAllCategoryData[] }> =
      yield call(shopApis.getAllProductByCategory);
    if (res.data.data) {
      yield put(actions.async.getAllProductByCategory.success(res.data.data));
    }
  } catch (error: any) {
    yield put(
      actions.async.getAllProductByCategory.fail(
        error.response?.data?.message || 'Failed to fetch products'
      )
    );
  }
}

export default function* sagas() {
  yield takeLatest(actions.async.getCategories.fetch, getCategories);
  yield takeLatest(actions.async.getSettingTax.fetch, getSettingTax);
  yield takeLatest(actions.async.getFeeCreditCard.fetch, getFeeCreditCard);
  yield takeLatest(actions.async.getCashIncentive.fetch, getCashIncentive);
  yield takeLatest(actions.async.getStaffs.fetch, getStaffs);
  yield takeLatest(actions.async.getShopInfo.fetch, getShopInfo);
  yield takeLatest(actions.async.getPaymentOthers.fetch, getPaymentOthers);
  yield takeLatest(actions.async.getLoyaltyProgram.fetch, getLoyaltyProgram);
  yield takeLatest(actions.async.getPackageVip.fetch, getPackageVip);
  yield takeLatest(actions.initData, initData);
  yield takeLatest(
    actions.async.getAllProductByCategory.fetch,
    getAllProductByCategory
  );
}
